import React, { useEffect, useState } from "react";
import "./style.scss";
import { Link, useNavigate } from "react-router-dom";
import Html from "./Html";
import environment from "../../../environment";
import { useSelector } from "react-redux";

// Le composeur de sidebar est démonté/remonté sur certaines navigations
// (pages /agency/* qui possèdent leur propre PageLayout). On conserve la
// position de scroll du menu pour ne pas revenir en haut à chaque clic.
let sidebarScrollTop = 0;

const Sidebar = ({ isOpen = true, onToggle = () => {}, menus, propertyTotal = 0 }) => {
  const user = useSelector((state) => state.user);
  const history = useNavigate();
  const [role, setRole] = useState(user.customerRole);

  // Restaure la position de scroll sauvegardée + enregistre les suivantes.
  useEffect(() => {
    const get = () => document.querySelector(".sidebar-block-sections");
    const node = get();
    if (node) node.scrollTop = sidebarScrollTop;
    const onScroll = () => {
      const el = get();
      if (el) sidebarScrollTop = el.scrollTop;
    };
    node?.addEventListener("scroll", onScroll);
    return () => node?.removeEventListener("scroll", onScroll);
  }, []);

  const menustabs = {
    user: ["roles", "users"],
    catalogue: ["types", "categories", "category/"],
    plan: ["features", "plans"],
    api: ["bookingSystem", "pos", "reviews", "accountingSystem"],
    geo: ["continents", "countries", "regions", "cities"],
    dynamicPricing: ["dynamicprice"],
    skills: ["skills", "skill-roles"],
  };

  const ListItemLink = ({ to, type = "link", disabled = false, ...rest }) => {
    let url = window.location.href;
    const host = window.location.host;
    url = url.split(host)[1];
    return (
      <>
        {type == "link" ? (
          <li
            className={`nav-item ${url.includes(to) ? "active" : ""} ${
              disabled ? "disabled" : ""
            }`}
          >
            {/* {...rest} */}
            <Link to={to} {...rest} className="" />
          </li>
        ) : (
          <li
            className={`nav-item main ${url.includes(to) ? "active" : ""}`}
            {...rest}
          ></li>
        )}
      </>
    );
  };

  const tabclass = (tab) => {
    let url = window.location.href;
    let value = false;
    menustabs[tab]?.map((itm) => {
      if (url.includes(itm)) value = true;
    });
    return value;
  };

 

  const isAllow = (url = "") => {
    let permissions = user?.permissions?.[0];
    let arr = url.split(",");
    let value = false;
    arr.map((itm) => {
      if (permissions?.[itm]) value = permissions?.[itm];
    });

    if (!url || user?.role?.name == "Admin") value = true;
    return value;
  };

  const route = (p) => {
    history(p);
  };

  return (
    <>
      <Html
        user={user}
        route={route}
        tabclass={tabclass}
        isAllow={isAllow}
        ListItemLink={ListItemLink}
        isOpen={isOpen}
        onToggle={onToggle}
        menus={menus}
        propertyTotal={propertyTotal}
      />
    </>
  );
};

export default Sidebar;
